import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const getJobModificationDetails = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job-modification/${jobId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching job modification details:", error);
    throw error;
  }
};

export const submitJobModification = async (payload, username, companyId) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job-modification`,
      payload,
      {
        params: {
          user: username,
          companyId: companyId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting job modification:", error);
    throw error;
  }
};

export const getRequestOtherRequests = async (requestId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job-modification/${requestId}/other-requests`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching other requests:", error);
    throw error;
  }
};